import request from '@/utils/request'

// 查询空间订单分页
export function pageSpaceOrder(data) {
  return request({
    url: '/space/order/page',
    method: 'post',
    data: data
  })
}

// 导出空间订单
export function exportSpaceOrder(data) {
  return request({
    url: '/space/order/export',
    method: 'post',
    data: data
  })
}
